import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/useAppSelector';
import { usePermissions } from '@/hooks/usePermissions';
import { resolveAccessibleLandingPath } from '@/utils/pageAccessEngine';
import { APP_HOME_FALLBACK } from '@/constants/authRoutes';

/** Legacy `/org` URL — redirect to the user's first permitted module dashboard. */
export function OrgDashboardRedirect() {
  const enabledModules = useAppSelector((s) => s.auth.enabledModules);
  const accessibleModules = useAppSelector((s) => s.auth.accessibleModules);
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const workspaceModule = useAppSelector((s) => s.auth.workspaceModule);
  const permissions = useAppSelector((s) => s.auth.user?.permissions ?? []);
  const roleCode = useAppSelector((s) => s.auth.user?.roleCode);
  const { has } = usePermissions();

  const target = resolveAccessibleLandingPath(
    {
      permissions,
      roleCode,
      enabledModules,
      accessibleModules,
      entryModule,
      hasPermission: has,
    },
    workspaceModule ?? entryModule,
  );

  return <Navigate to={target || APP_HOME_FALLBACK} replace />;
}
